import { useForm, usePage, Link } from "@inertiajs/react";
import AuthLayout from "@/layout/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";

export default function ResetPassword() {
  const { routes, form_action } = usePage().props;
  const form = useForm({ password: "", password_confirmation: "" });

  function submit(e) {
    e.preventDefault();
    form.put(form_action);
  }

  return (
    <AuthLayout>
      <Card>
        <CardHeader>
          <CardTitle>Set a new password</CardTitle>
          <CardDescription>Choose a strong password for your account.</CardDescription>
        </CardHeader>

        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="password">New password</Label>
              <Input
                id="password"
                type="password"
                autoComplete="new-password"
                autoFocus
                placeholder="At least 8 characters"
                value={form.data.password}
                onChange={(e) => form.setData("password", e.target.value)}
              />
              {form.errors.password && (
                <p className="text-xs text-destructive">{form.errors.password}</p>
              )}
            </div>

            <div className="space-y-1.5">
              <Label htmlFor="password_confirmation">Confirm new password</Label>
              <Input
                id="password_confirmation"
                type="password"
                autoComplete="new-password"
                placeholder="••••••••"
                value={form.data.password_confirmation}
                onChange={(e) => form.setData("password_confirmation", e.target.value)}
              />
              {form.errors.password_confirmation && (
                <p className="text-xs text-destructive">{form.errors.password_confirmation}</p>
              )}
            </div>

            <Button type="submit" className="w-full" disabled={form.processing}>
              {form.processing ? "Saving…" : "Save new password"}
            </Button>
          </form>
        </CardContent>

        <CardFooter className="justify-center text-sm text-muted-foreground">
          <Link href={routes.login} className="text-primary hover:underline font-medium">
            Back to sign in
          </Link>
        </CardFooter>
      </Card>
    </AuthLayout>
  );
}
